export const PSADismissed = 'PSADismissed'
export const PSAClick = 'PSAClick'
export const PSALoaded = 'PSALoaded'
